<script setup lang="ts">
const props = defineProps<{
  imageSizeClass: string
}>()
</script>

<template>
  <a
    class="tw-inline-block"
    href="https://play.google.com/store/apps/details?id=com.riserapp&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    target="_blank"
  >
    <img
      :class="props.imageSizeClass"
      alt="Get it on Google Play"
      src="/images/google_play_store.svg"
    />
  </a>
</template>
